<template>
  <Modal name="TUTORIAL_MODAL" title="Tutorial" width="720">
    <template v-slot:body>
      <p v-if="description" class="mb-5">
        {{ description }}
      </p>
      <v-carousel
        v-if="videos"
        :continuous="false"
        :class="`tutorial ${videos.length > 1 ? 'multiple' : ''}`"
        height="auto"
      >
        <v-carousel-item
          v-for="item in videos"
          :key="item"
          class="tutorial__item"
        >
          <div class="embedded">
            <iframe
              :src="
                `https://www.youtube.com/embed/${item}?rel=0&showinfo=0&autohide=1&modestbranding=1`
              "
              frameborder="0"
              allowfullscreen
            />
            <v-progress-circular
              :size="50"
              :width="5"
              class="embedded__fake-loading"
              color="white"
              indeterminate
            />
          </div>
        </v-carousel-item>
      </v-carousel>
    </template>
  </Modal>
</template>

<script>
import { mapMutations } from 'vuex'
import Modal from '@/components/app/Modal'

export default {
  name: 'ModalTutorial',

  components: {
    Modal,
  },

  data() {
    return {
      videos: null,
      description: null,
    }
  },

  methods: {
    ...mapMutations(['openModal', 'closeAllModals']),

    checkTutorialUrlParams() {
      const params = this.$route.query

      if (params.videos) {
        const videos = this.$route.query.videos.split(',')
        this.videos = videos
      }

      if (params.description) {
        this.description = params.description
      }

      if (params.videos || params.description) {
        this.openModal('TUTORIAL_MODAL')
      }
    },
  },

  mounted() {
    this.checkTutorialUrlParams()
  },

  beforeDestroy() {
    this.closeAllModals()
    this.videos = null
    this.description = null
  },
}
</script>
